module.exports = __webpack_public_path__ + "static/media/butt03.1b589585.png";